import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let fullPageTheme = createTheme({
    palette: {
        background: {
            default: '#ffffff' // Clean white background
        },
        text: {
            primary: '#333333' // Standard text color for readability
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14, // Default font size
    },
    spacing: 8, // Default spacing
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: 0,
                    margin: 0,
                    border: 'none',
                    boxShadow: 'none'
                }
            }
        }
    }
});

fullPageTheme = responsiveFontSizes(fullPageTheme);

let paperTheme = createTheme({
    palette: {
        background: {
            paper: '#ffffff'
        },
        text: {
            primary: '#333333'
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
    },
    spacing: 8,
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    margin: 'auto', // Centers the paper
                    border: '1px solid #ccc', // Light border for a "paper" effect
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)', // Subtle shadow
                    padding: '2rem', // Ensures readability
                    maxWidth: '1000px', // Broader width
                    width: 'calc(100% - 6rem)', // Responsive width
                    boxSizing: 'border-box', // Ensures proper width calculation
                    backgroundColor: '#ffffff', // Explicit background

                    // ✅ Dynamic Top Margin for Navbar Presence
                    marginTop: 'var(--navbar-height, 1rem)', // Uses a CSS variable, defaulting to 2rem if not set
                }
            }
        }
    }
});

paperTheme = responsiveFontSizes(paperTheme);

const themes = {
    "Paper": paperTheme,
    "Full Page": fullPageTheme,
    // Add more themes as needed
};

export default themes;
